/**
 * Checks whether a permission map contains the requested permission.
 */
export function hasPermissionInMap(map: Record<string, boolean>, permission: string) {
  if (permission.startsWith('*')) {
    const suffix = permission.slice(1);

    for (const key of Object.keys(map)) {
      if (key.endsWith(suffix) && map[key]) {
        return true;
      }
    }
  }

  return !!map[permission];
}
